.c1{overflow:hidden;}